'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _isAway = require('conversations-schema/operators/agent-state/isAway');

var _isBusy = require('conversations-schema/operators/agent-state/isBusy');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeprecatedStatusIndicator = function (_Component) {
  _inherits(DeprecatedStatusIndicator, _Component);

  function DeprecatedStatusIndicator() {
    _classCallCheck(this, DeprecatedStatusIndicator);

    return _possibleConstructorReturn(this, (DeprecatedStatusIndicator.__proto__ || Object.getPrototypeOf(DeprecatedStatusIndicator)).apply(this, arguments));
  }

  _createClass(DeprecatedStatusIndicator, [{
    key: 'getVisitorIndicatorClass',
    value: function getVisitorIndicatorClass() {
      var responder = this.props.responder;

      /**
       * In the visitor widget, status indicators are to be green
       * unless the assigned agent is AWAY
       */

      switch (true) {
        case (0, _isAway.isAway)(responder):
          return 'status-indicator-grey';

        default:
          return 'status-indicator-green';
      }
    }
  }, {
    key: 'getInboxIndicatorClass',
    value: function getInboxIndicatorClass() {
      var responder = this.props.responder;

      /**
       * In the inbox, status indicators are to be yellow if the agent is BUSY,
       * grey if the agent is AWAY and green otherwise
       */

      switch (true) {
        case (0, _isBusy.isBusy)(responder):
          return 'status-indicator-yellow';

        case (0, _isAway.isAway)(responder):
          return 'status-indicator-grey';

        default:
          return 'status-indicator-green';
      }
    }
  }, {
    key: 'getIndicatorClass',
    value: function getIndicatorClass() {
      return this.props.isVisitorWidget ? this.getVisitorIndicatorClass() : this.getInboxIndicatorClass();
    }
  }, {
    key: 'render',
    value: function render() {
      var size = this.props.size;

      var className = 'chat-head-icon chat-head-status ' + size + ' ' + this.getIndicatorClass();

      return _react2.default.createElement('div', { className: className });
    }
  }]);

  return DeprecatedStatusIndicator;
}(_react.Component);

DeprecatedStatusIndicator.propTypes = {
  isVisitorWidget: _react.PropTypes.bool.isRequired,
  responder: (0, _RecordPropType2.default)('Responder').isRequired,
  size: _react.PropTypes.string.isRequired
};

DeprecatedStatusIndicator.defaultProps = {
  isVisitorWidget: false
};

exports.default = DeprecatedStatusIndicator;
module.exports = exports['default'];